export default function filterItems(items, searchTerm = '') {
	return items.filter((item) => (
		item.settings.title.toLowerCase().trim().includes(searchTerm.toLowerCase().trim())
	));
}
